import qs from 'qs';

export const useRequestBody = () => {
  /**
   * 受け取ったボディをパースする
   * @param req ボディ
   * @returns {any}
   */
  const parseRequestBody = async (req: any): Promise<any> => {
    const body = await readRequestBody(req);
    const parsedBody = qs.parse(body);

    if (!(parsedBody?.article_preview && typeof parsedBody.article_preview === 'string')) return;

    const reqBody = JSON.parse(parsedBody.article_preview);

    return reqBody.result[0];
  };

  /**
   * ボディの非連続データを一つの文字列にする
   * @param req ボディ
   * @returns {any}
   */
  const readRequestBody = async (req: any) =>
    new Promise<string>((resolve) => {
      let data = '';

      req.on('readable', () => {
        data += req.read() || '';
      });
      req.on('end', () => {
        resolve(data);
      });
    });

  return {
    parseRequestBody,
  };
};
